<script lang="ts">
	import { Card } from "flowbite-svelte";
	import { twMerge } from "tailwind-merge";
	import type { ComponentProps } from "#lib/components/page/ComponentProps.js";
	import { stringValue, structValue } from "#lib/struct.js";

	let { id, style, page, children }: ComponentProps = $props();

	const config = $derived(structValue($page.config, id));
</script>

<Card {...config} class={twMerge("flex flex-col items-center pb-4", stringValue(config, "class") ?? "")} {style}>
	{@render children?.()}
</Card>
